import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher/Dispatcher';
import { getLang } from '../common/lang';


class RepairClockInStore extends ReduceStore {

	getInitialState() {
		return {};
	}

	reduce(state, action) {
		switch (action.type) {
			case 'get-emp-rci-exlist':
				return {
					...state,
					rciList: action.data,
					status: 'loaded'
				};
			case 'get-emp-rci-exlist-detail':
				return {
					...state,
					record: action.data,
					status: 'loaded'
				};
			case 'get-emp-rci-period-list':
				return {
					...state,
					status: 'loaded',
					periodList: action.data
				};
			case 'get-rci-form':
				return {
					...state,
					status: 'loading'
				};
			case 'get-rci-form-success':
				return {
					...state,
					rciForm: action.data.formConfig,
					status: 'loaded'
				};
			case 'insert-rci-form':
				return {
					...state,
					submitting: true
				};
			case 'insert-rci-form-fail':
			case 'insert-rci-form-success':
				return {
					...state,
					submitting: false,
					refreshList: action.type === 'insert-rci-form-success'
				};
			case 'get-emp-rci-list':
				return {
					...state,
					empRciListQuery: action.data,
					status: 'loading'
				};
			case 'get-emp-rci-list-fail':
				return {
					...state,
					status: 'loaded'
				};
			case 'get-emp-rci-list-success':
			//console.log(action.data);
				return {
					...state,
					empRciList: state.empRciListQuery.page === 1 ? action.data : state.empRciList.concat(action.data),
					status: 'loaded'
				};
			case 'get-emp-rci-record':
				return {
					...state,
					status: 'loading'
				};
			case 'get-emp-rci-record-fail':
				return {
					...state,
					status: 'loaded'
				};
			case 'get-emp-rci-record-success':
				return {
					...state,
					empRciRecord: action.data,
					status: 'loaded'
				};
			case 'get-rci-pending-records':
				return {
					...state,
					pendingQuery: action.data,
					status: 'loading'
				};
			case 'get-rci-pending-records-fail':
				return {
					...state,
					status: 'loaded'
				};
			case 'get-rci-pending-records-success':
				return {
					...state,
					pendingRecords: state.pendingQuery.page === 1 ? action.data : state.pendingRecords.concat(action.data),
					status: 'loaded'
				};
			//审批通过或拒绝
			case 'approve-rci-pending-record-success':
				return history.back();
			case 'check-rci-ex-list-success':
				return {
					...state,
					pid: action.data
				};
			case 'close-rci-record-selectable':
				return {
					...state,
					selectable: false
				};
			case 'get-rci-filter-success':
				return {
					...state,
					filter: {
						items: (action.data.map ? action.data : []).map(item => {
							return {
								...item,
								text: item[getLang() + '_text'],
								name: item.value
							};
						})
					}
				};
			default:
				return state;
		}
	}
}


export default new RepairClockInStore(Dispatcher);



// WEBPACK FOOTER //
// ./src/stores/RepairClockInStore.js